import {Box,useToast,SkeletonCircle,SkeletonText} from '@chakra-ui/react'
import {useState,useEffect } from 'react'

import { getPopisData,updateUkljuciUPopis,updatePopisGovedoItem,getPopisGovedoXlsx,deletePopisGovedo } from '../../util/apiMRgg';
import { insertSpecifikacijaFromPopis } from '../../util/apiSpecifikacija';
import PopisGovedaDetailTable from './PopisGovedaDetailTable';

export default function PopisGovedaDetail({rgg_id,onSelectGovedo,tableSize='xs',readonly=false,onCreateSpecifikacija,onClose,onDelPopis}) {
    const [data, setData] = useState([])
    const [isgeneratingexcel,setIsGeneratingExcel]=useState(false);
    const [isgeneratinspec,setIsGeneratingSpec]=useState(false);
    const [togglerefresh,setToggleRefresh]=useState(false);
    const [isloading,setIsLoading]=useState(false);
    const [specifikacijaisgenerated,setSpecifikacijaIsGenerated]=useState(true);
    const [errmsg,setErrMsg]=useState("");
    const [successmsg,setSuccessMsg]=useState("");
    const toast=useToast();
    useEffect(() => {
      const loadData=async()=>{
        try {
            setIsLoading(true);
            const res=await getPopisData(rgg_id);
            if (res.status===200) {
              setData(res.res);  
              if (res.res[0].specifikacija_id===0) {
                setSpecifikacijaIsGenerated(false);
              }
            } else {
              throw new Error(res.message);
            }
            
        } catch (error) {
          toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
        } finally {
           setIsLoading(false);
        }
      }
    loadData();
      
    }, [togglerefresh])
    
    const UkljuciUIspisChanged=async (popisgovedoid,ukljuci)=>{
      let ermsg="";
      let warningmsg="";
      const _d=[...data];
      const _idx=_d.findIndex((item)=>item.id===popisgovedoid);
      if (_idx!==-1) {
        
        
        try {
          if (_d[_idx].govedo_id===0) {
            warningmsg="Govedo ne postoji u registru te se stoga ne može uključiti u pripremu za specifikaciju!"
          } else if (_d[_idx].govedo_migracija_id===0) {
            warningmsg="Govedo se više ne nalazi u registru te stoga ne može biti uključeno u specifikaciju!"
          } else {
            _d[_idx].ukljuciupopis=ukljuci;
            setData(_d);
          const res=await updateUkljuciUPopis(popisgovedoid,ukljuci)
          if (res.status!==200) {
            ermsg=res.message;
          } 
        }
        } catch (error) {
          ermsg=error.message;
        }
        finally {
          if (ermsg!=="") {
            toast({
              title:"Greška kod dohvata podataka.",
              status:"error",
              description:ermsg,
              isClosable:true,
              duration:2500,
              position:"top-right",
          });
          }

          if (warningmsg!=="") {
            toast({
              title:"RGG",
              status:"warning",
              description:warningmsg,
              isClosable:true,
              duration:2500,
              position:"top-right",
          });
          }
        }
      }
      
    }

    const updateItem=async (_id,_zivbr,_rfid,_spol,_passif,_boksid,_odjeljak,_toviliste,_lokacija,_updatergg)=>{
      let _msg="Podaci uspješno ažurirani";
      let _err=false;
      try {
        const _res=await updatePopisGovedoItem(_id,_zivbr,_rfid,_spol,_passif,_boksid,_updatergg);
        if (_res.status!==200) {
          _msg=_res.message;
          _err=true;
        } else {
          const _d=[...data]
          const _idx=_d.findIndex((item)=>item.id===_id);
          if (_idx!==-1) {
            _d[_idx].zivbr=_zivbr;
            _d[_idx].rfid=_rfid;
            _d[_idx].spol=_spol;
            _d[_idx].pasmina_sifra=_passif;
            _d[_idx].boks_id=_boksid;
            _d[_idx].lokacija=_lokacija;
            _d[_idx].toviliste=_toviliste;
            _d[_idx].odjeljak=_odjeljak;
            setData(_d)
            setToggleRefresh(!togglerefresh);
          }
        }
      } catch (error) {
        _msg=error.message;
        _err=true;
      } finally {
        toast({
          title:"RGG",
          status:_err?"error":"success",
          description:_msg,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });
      }
    }
    const getExcelReport=async ()=>{
      try {
        setIsGeneratingExcel(true)
          const _res=await getPopisGovedoXlsx(rgg_id);
          const blob = new Blob([_res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "popisgoveda.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
      } catch (error) {
          toast({
              title:"RGG",
              status:"error",
              description:error.message,
              isClosable:true,
              duration:2500,
              position:"top-right",
          });
      } finally {
        setIsGeneratingExcel(false);
      }

  }
  const CreateSpecifikacija=async ()=>{
    let msg="";
    try {
      setIsGeneratingSpec(true);
      const res=await insertSpecifikacijaFromPopis(rgg_id,new Date().toISOString().split("T")[0],"");
      if (res.status===200) {
        const brgrla=res.res.rowsaffected;
        const specid=res.res.specifikacijaid;
        onCreateSpecifikacija();
        toast({
          title:"RGG",
          status:'success',
          description:`Kreirana specifikacija id: ${specid}. Uključeno ${brgrla} goveda.`,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });
      } else {
        msg=res.message;
      }
    } catch (error) {
      msg=error.message;
      
    } finally {
      if (msg!=="") {
        toast({
          title:"RGG",
          status:"error",
          description:msg,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });  
      setIsGeneratingSpec(false);
      }
    }
  }
  const showMessage=()=>{
    if (errmsg!=="") {
      
        toast({
          title:"RGG",
          status:'error',
          description:errmsg,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });
      setErrMsg("");
    }
    if (successmsg!=="") {
      
        toast({
          title:"RGG",
          status:'success',
          description:successmsg,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });
      setSuccessMsg("");
    
      
    }
  }
  const handleDeletePopis=()=>{
    onDelPopis(rgg_id);
  }
  const handleDeletePopisGovedo= async(_popisgovedoid)=>{
    let _msg="";
    try {
      const _res=await deletePopisGovedo(_popisgovedoid);
      if (_res.status!==200) {
        _msg=_res.message;
      } else {
        setToggleRefresh(!togglerefresh);
      }
    } catch (error) {
      _msg=error.message;
    } finally {
      if (_msg!=="") {
        setErrMsg(_msg);
      } else {
        setSuccessMsg("Brisanje podatka uspješno provedeno");
      }
    }
    
  }
    const buildScreen=()=>{
        if (isloading || data.length===0) {
          return (
            <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%' flex={1}>
              <SkeletonCircle size='10' />
              <SkeletonText mt='4' noOfLines={10} spacing='4' skeletonHeight='2' />
            </Box>
          )
        } else {
          return (
            <Box display={'flex'} flexDir={'column'} alignItems={'center'} flex={1}>
                  <PopisGovedaDetailTable isGeneratingSpec={isgeneratinspec} isGeneratingReport={isgeneratingexcel} goveda={data} onGetReportExcel={getExcelReport} onUkljuciUIspisChanged={UkljuciUIspisChanged} onUpdateGovedoInRgg={(id,zivbr,rfid,spol,passif,boksid,odjeljak,toviliste,lokacija)=>updateItem(id,zivbr,rfid,spol,passif,boksid,odjeljak,toviliste,lokacija,true)} 
                  onSavePopisGovedo={(id,zivbr,rfid,spol,passif,boksid,odjeljak,toviliste,lokacija)=>updateItem(id,zivbr,rfid,spol,passif,boksid,odjeljak,toviliste,lokacija,false)}
                  onCreateSpec={CreateSpecifikacija} readonly={specifikacijaisgenerated} onDeletePopisGovedo={handleDeletePopisGovedo} onDeletePopis={handleDeletePopis}/>
            </Box>
          )
        }
      }
    return (
        <Box display={'flex'} flex={1} flexDir={'column'} w={'100%'}>
            {buildScreen()}
            {showMessage()}
        </Box>
    )
}